<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import 'element-ui/lib/theme-chalk/index.css';

export default {
  name: 'App',
  components: {},
  mounted() {},
  computed: mapState({
    ui: state => state.ui,
    user: state => state.user,
  }),
  methods: {
    initMenu() {},
  },
};
</script>
<style lang="sass">
   @import 'assets/css/sb-admin-2.css';
   @import 'assets/css/style.css';
   @import 'assets/css/grid.css';
   @import 'assets/css/all.css';
   @import 'assets/css/bmo.css';
</style>